import React, { useState, useCallback, useContext, ReactNode } from "react";
import { DropdownMenu } from "../DropdownMenu";
import { useTranslation } from "react-i18next";
import { HMIContext } from "../../contexts/HMIContext/HMIContext";
import { SelectChangeEvent } from "@mui/material/Select/Select";
import { getHMIDisplayUnit, setHMIDisplayUnit } from "utilities/storageUtilities";
import { IDowntimeDisplayUnitDropdownProps } from "./DowntimeDisplayUnitsDropdownInterfaces";

const storedDisplayUnit = getHMIDisplayUnit();

export const DowntimeDisplayUnitsDropdown = ({ bigSize }: IDowntimeDisplayUnitDropdownProps) => {
    const { t, i18n } = useTranslation();
    const [dropdownValue, setDropdownValue] = useState(t(storedDisplayUnit ? storedDisplayUnit : "minutes"));
    const { handleDisplayUnit } = useContext(HMIContext);

    const tKeys = {
        base: "downtime_display_units_dropdown",
        title: "title",
        optionsHolder: "downtime_display_units_dropdown_options",
        key: "option",
    };

    const downtimeDisplayUnitsDropdownOptions =
        i18n.language.slice(0, 2) === "en"
            ? [
                  { id: "minutes", name: "Minutes" },
                  { id: "occurrences", name: "Occurrences" },
              ]
            : i18n.language.slice(0, 2) === "fr"
            ? [
                  { id: "minutes", name: "Minutes" },
                  { id: "occurrences", name: "Occurrences" },
              ]
            : [
                  { id: "minutes", name: "Minutos" },
                  { id: "occurrences", name: "Ocurrencias" },
              ];

    const handleChange = useCallback(
        (event: SelectChangeEvent<string>, child: ReactNode): void => {
            setDropdownValue(event?.target.value);
            setHMIDisplayUnit(event?.target.value);
            handleDisplayUnit(event?.target.value);
        },
        [handleDisplayUnit],
    );

    return (
        <div>
            <DropdownMenu
                dropdownValue={dropdownValue}
                handleChange={handleChange}
                tKeys={tKeys}
                options={downtimeDisplayUnitsDropdownOptions}
                bigSize={bigSize}
            />
        </div>
    );
};
